import React from 'react';
import moment from 'moment';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import QueryStringService from '../../services/queryStringService.js';
import NumberRounding from '../../utils/numberRounding.js'; 


export default class PanelExportButton extends React.Component {
    constructor() {
        super();
        this.queryStringService = new QueryStringService();
        this.state = {
        };

        this.exportToExcel = this.exportToExcel.bind(this);
    }

    exportToExcel() {
        let panels = [];
        let country = this.queryStringService.getCurrentCountry();
        if (this.props.campaignType === 'posting') {
            panels = this.props.panels.map((panel, i) => {
                if (country == 'dk') {
                    if (this.props.packageType === 'CP02') {
                        return {
                            Panel: `${panel.panelId}`,
                            Address: `${panel.address}`,
                            PostalCode: `${panel.postalCode}`,
                            City: `${panel.city}`,
                            Shop: `${panel.alternateAddress}`,
                            County: `${panel.county}`,
                            Region: `${panel.region}`,
                            Status: `${panel.status}`,
                            Timestamp: `${moment(panel.timeStamp).format('YYYY-MM-DD HH:mm')}`,
                            Design: `${panel.design}`,
                            Latitude: `${panel.latitude}`,
                            Longitude: `${panel.longitude}`,
                            Info: `${panel.debugInfo}`
                        };
                    } else {
                        return {
                            Panel: `${panel.panelId}`,
                            Address: `${panel.address}`,
                            PostalCode: `${panel.postalCode}`,
                            City: `${panel.city}`,
                            County: `${panel.county}`,
                            Region: `${panel.region}`,
                            Status: `${panel.status}`,
                            Timestamp: `${moment(panel.timeStamp).format('YYYY-MM-DD HH:mm')}`,
                            Design: `${panel.design}`,
                            Latitude: `${panel.latitude}`,
                            Longitude: `${panel.longitude}`,
                            Info: `${panel.debugInfo}`
                        };
                    }
                } else {
                    return {
                        Panel: `${panel.panelId}`,
                        Address: `${panel.address}`,
                        PostalCode: `${panel.postalCode}`,
                        City: `${panel.city}`,
                        Region: `${panel.region}`,
                        Status: `${panel.status}`,
                        Timestamp: `${moment(panel.timeStamp).format('YYYY-MM-DD HH:mm')}`,
                        Design: `${panel.design}`,
                        Latitude: `${panel.latitude}`,
                        Longitude: `${panel.longitude}`,
                        Info: `${panel.debugInfo}`
                    };
                }
            });
        } else {
            panels = this.props.panels.map((panel, i) => {
                if (this.props.exportPanelSOVValue) {
                    return {
                        Panel: `${panel.panelId}`,
                        Region: `${panel.region}`,
                        City: `${panel.city}`,
                        Address: `${panel.address}`,
                        PostalCode: `${panel.postalCode}`,
                        Status: `${panel.status}`,
                        Latitude: `${panel.latitude}`,
                        Longitude: `${panel.longitude}`,
                        Environment: `${panel.environment}`,
                        SOV: `${NumberRounding.round((!isNaN(panel.soV) && typeof panel.soV !== "number" ? 0.0 : +panel.soV) * 100, 2)}`,
                        faceid: `${panel.externalKey ? panel.externalKey : ""}`
                    };
                }
                else {
                    return {
                        Panel: `${panel.panelId}`,
                        Region: `${panel.region}`,
                        City: `${panel.city}`,
                        Address: `${panel.address}`,
                        PostalCode: `${panel.postalCode}`,
                        Status: `${panel.status}`,
                        Latitude: `${panel.latitude}`,
                        Longitude: `${panel.longitude}`,
                        Environment: `${panel.environment}`
                    };
                }
            });
        }
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const fileExtension = '.xlsx';
        const ws = XLSX.utils.json_to_sheet(panels);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });

        var ua = window.navigator.userAgent;
        if (ua.match(/Edge/)) {
            window.navigator.msSaveBlob(data,
                'PoP-' + `${this.props.campaignName}` + '-' + `${moment().format('YYYY-MM-DD HH:mm')}` + fileExtension);
        } else {
            FileSaver.saveAs(data, 'PoP-' + `${this.props.campaignName}` + '-' + `${moment().format('YYYY-MM-DD HH:mm')}` + fileExtension);
        }
    }

    render() {
        let colorClass = 'btn-play';
        if (this.props.campaignType === 'posting') {
            colorClass = 'btn-posting';
        }

        return (
            <div >
                <button disabled={!this.props.allowAddressExport} className={'btn ' + colorClass + ' hidden-print'}
                    target='_blank'
                    onClick={() => { this.exportToExcel(this.props.panels) }}
                    >
                        Export address list
                </button>
            </div>
        );
    }
}